export const yellow = {
  100: '#3D3723',
  200: '#6A5929',
  300: '#967A2F',
  400: '#C39C35',
  500: '#EFBD3B',
  600: '#F2CA62',
  700: '#F5D789',
  800: '#F9E5B1',
  900: '#FCF2D8',
} as const;
